import { TFunction } from 'react-i18next'
import * as yup from 'yup'
import { useYupFields } from 'hooks/forms/useYupFields'

export type CustomerFeeWalletFormData = {
  walletReference: string
}

export type CustomerFeeWalletFormKeys = keyof CustomerFeeWalletFormData

export const customerFeeWalletSchema = (t: TFunction<'translation', undefined>) => {
  const { getRequiredYupField } = useYupFields()

  return yup.object<Record<CustomerFeeWalletFormKeys, yup.AnySchema>>({
    walletReference: getRequiredYupField({
      label: t('customers.feeSetup.selectWallet'),
    }),
  })
}
